import { CloseOutlined } from "@ant-design/icons";
import { AgGridReact } from "ag-grid-react";
import { Tooltip } from "antd";
import { TTitleParams } from "components/ciq-grid-view-wrapper/model";

const getStats = (titleParam: TTitleParams | undefined) => {
  if (!titleParam) return "";

  const { filterStats, totalCount } = titleParam;

  if (filterStats && totalCount) {
    if (filterStats.filterName) {
      return (
        <>
          <span>
            {filterStats.displayCount} of {totalCount}
          </span>
          <span className="px-1">{filterStats.filterName}</span>
        </>
      );
    }
    if (filterStats.displayCount === totalCount)
      return filterStats.displayCount;
    return `${filterStats.displayCount} of ${totalCount}`;
  }
  if (totalCount) return totalCount;
  return "";
};

export const getGridStatusBudge = (
  titleParam: TTitleParams | undefined,
  onAllRecordsClick?: () => void
) => {
  const stats: any = getStats(titleParam);
  if (stats === "") {
    return null;
  }
  if (stats.props) {
    return (
      <div
        className="flex items-center gap-2 shrink-0"
        data-testid="grid-status-badge-group"
      >
        <div
          className="flex flex-wrap items-center border border-solid border-ciq-gray-300 rounded-xl px-2 py-0.5 text-black text-opacity-50 text-xs font-normal"
          data-testid="grid-status-badge"
        >
          {stats.props.children[0]}
        </div>
        <Tooltip title={`Remove to view all ${titleParam?.title}`}>
          <div
            className="flex flex-wrap items-center border border-solid rounded-xl px-2 py-0.5 text-opacity-90 text-xs font-normal bg-ciq-blue-100 text-ciq-blue-700 border-ciq-blue-300"
            data-testid="grid-status-badge-title"
          >
            {stats.props.children[1]}
            <CloseOutlined
              className="mt-[3px] text-xs text-ciq-blue-700"
              style={{ fontSize: 10 }}
              onClick={onAllRecordsClick}
            />
          </div>
        </Tooltip>
      </div>
    );
  }
  return (
    <div className="flex flex-wrap items-center border border-solid border-ciq-gray-300 rounded-xl px-2 py-0.5 text-black text-opacity-50 text-xs font-normal">
      {stats}
    </div>
  );
};

const getDisplayedCountForCustomReport = (gridRef: any) => {
  let leaf = 0;
  gridRef.current!.api.forEachNodeAfterFilterAndSort((node: any) => {
    if (!node.group && !node.data.shodowRow) leaf += 1;
  });
  return leaf;
};

export const calculateCustomReportStats = (props: {
  gridRef: React.RefObject<AgGridReact<any>>;
}) => {
  const { gridRef } = props;
  if (!gridRef.current?.api) return undefined;
  const isAnyFilterPresent = gridRef.current?.api.isAnyFilterPresent();
  if (!isAnyFilterPresent) return undefined;

  const displayedRowCount = getDisplayedCountForCustomReport(gridRef);
  // getDisplayedCountForCustomReport always returns a number (leaf starts at 0
  // and is only ever incremented), so this can never be undefined — dead guard.
  /* v8 ignore next */
  if (displayedRowCount === undefined) return undefined;

  const data = {
    displayCount: displayedRowCount,
    filterName: undefined
  };

  return data;
};
